import { QuestionnaireAnswerType } from 'components/Assessments/types'
import { CareCoordinationQuestionnaireItem } from './questionnaire'

export const CARE_COORDINATION_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  [CareCoordinationQuestionnaireItem.MEDICAL_BACKGROUND_CARE_COORDINATION_PREVIOUS_APPOINTMENTS]:
    QuestionnaireAnswerType.STRING,
  [CareCoordinationQuestionnaireItem.MEDICAL_BACKGROUND_CARE_COORDINATION_FUTURE_APPOINTMENTS]:
    QuestionnaireAnswerType.STRING,
  [CareCoordinationQuestionnaireItem.MEDICAL_BACKGROUND_CARE_COORDINATION_CARE_TEAM_COORDINATION]:
    QuestionnaireAnswerType.STRING,
  [CareCoordinationQuestionnaireItem.MEDICAL_BACKGROUND_CARE_COORDINATION_ORDERS_FOR_TREATMENT]:
    QuestionnaireAnswerType.STRING,
  [CareCoordinationQuestionnaireItem.MEDICAL_BACKGROUND_CARE_COORDINATION_DATE_OF_VERBAL_COMMUNICATION]:
    QuestionnaireAnswerType.DATE_TIME
}
